import { render, staticRenderFns } from "./ProductVersionPricesTable.vue?vue&type=template&id=269b7790&scoped=true"
import script from "./ProductVersionPricesTable.vue?vue&type=script&lang=ts"
export * from "./ProductVersionPricesTable.vue?vue&type=script&lang=ts"
import style0 from "./ProductVersionPricesTable.vue?vue&type=style&index=0&id=269b7790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269b7790",
  null
  
)

export default component.exports